import { render, staticRenderFns } from "./Atividade_1.vue?vue&type=template&id=23ff0e4c&scoped=true"
import script from "./Atividade_1.vue?vue&type=script&lang=js"
export * from "./Atividade_1.vue?vue&type=script&lang=js"
import style0 from "./Atividade_1.vue?vue&type=style&index=0&id=23ff0e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff0e4c",
  null
  
)

export default component.exports